import { createFileRoute, redirect } from "@tanstack/react-router";

// The funnel's first question IS the email question, so signing up and
// onboarding are one surface now. This route survives only so links already in
// the wild (the public fact sheet's footer) still land somewhere real.
export const Route = createFileRoute("/sign-up")({
  beforeLoad: () => {
    throw redirect({ to: "/onboarding", search: {} });
  },
});
